import { Component, OnInit } from '@angular/core';

import { BreadcrumService, BreadcrumLocation } from '../services/breadcrum.service';
import { Subscription } from 'rxjs/Subscription';
import { AutoUnsubscribe } from '../decoractors/AutoUnsubscribe';

@Component({
    selector: 'fw-breadcrum',
    template: require('./breadcrum.component.html'),
    styles: [require('./breadcrum.component.css')]
})

@AutoUnsubscribe()
export class BreadcrumComponent implements OnInit {
    private currentLocationSubscription: Subscription;
    private currentNavigationLocation: BreadcrumLocation;


    constructor(private breadcrumService: BreadcrumService) { }

    ngOnInit() {
        this.currentLocationSubscription = this.breadcrumService.currentLocationChanged
            .subscribe((event: BreadcrumLocation) => {
                setTimeout(() => {
                    this.currentNavigationLocation = event;
                });
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/breadcrum/breadcrum.component.ts